import flapClientFactory from 'Utils/api/flap-client-factory';

/**
 * Axios instance to make Flap Content requests for from web-u client to web-u server
 */
const content = flapClientFactory('FLAP Content', '/api/v2/content-gateway');
export default content;
